/**
 * Add-to-cart handler for the custom product block (#add-to-cart-form / .product-add-button).
 * The block uses a plain {% form 'product' %} that is NOT wrapped in the theme's
 * <product-form> element, so by default it does a native POST and redirects to /cart.
 *
 * This script makes that button behave like the rest of the theme:
 *   - requires an explicit size selection (shows an inline error otherwise),
 *   - adds to cart via AJAX,
 *   - opens the cart drawer instead of redirecting.
 */
(function () {
  function init() {
    var form = document.getElementById("add-to-cart-form");
    if (!form || form.dataset.ajaxBound === "true") return;
    form.dataset.ajaxBound = "true";

    var variantInput = document.getElementById("selected-variant-id");
    var button = form.querySelector(".product-add-button");

    // The sticky add-to-cart bar has its own <select name="id"> that pre-selects the
    // first variant. Keep it in sync with the size grid and require an explicit choice.
    var stickySelect = document.querySelector('.m-sticky-addtocart select[name="id"]');
    var sizeOptions = document.querySelectorAll(".size-option");

    // Require an explicit size choice: never start with a pre-selected variant.
    if (variantInput) variantInput.value = "";
    if (stickySelect) stickySelect.value = "";

    var errorEl = document.createElement("div");
    errorEl.className = "product-add-error";
    errorEl.setAttribute("role", "alert");
    errorEl.style.display = "none";
    form.appendChild(errorEl);

    function showError(message) {
      errorEl.textContent = message;
      errorEl.style.display = "block";
    }

    function clearError() {
      errorEl.textContent = "";
      errorEl.style.display = "none";
    }

    function highlightSize(variantId) {
      sizeOptions.forEach(function (opt) {
        opt.classList.toggle("selected", opt.getAttribute("data-variant-id") === variantId);
      });
    }

    // Choosing a size in the grid updates both the main form and the sticky bar.
    sizeOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        if (option.classList.contains("unavailable")) return;
        var variantId = option.getAttribute("data-variant-id");
        if (variantInput) variantInput.value = variantId;
        if (stickySelect && stickySelect.value !== variantId) {
          stickySelect.value = variantId;
          stickySelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
        highlightSize(variantId);
        clearError();
      });
    });

    // Choosing a size from the sticky bar dropdown updates the grid + main form.
    if (stickySelect) {
      stickySelect.addEventListener("change", function () {
        var variantId = stickySelect.value;
        if (!variantId) return;
        if (variantInput) variantInput.value = variantId;
        highlightSize(variantId);
        clearError();
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      clearError();

      if (!variantInput || !variantInput.value) {
        showError("Please select a size before adding to cart.");
        return;
      }

      var settings = window.MinimogSettings || {};
      var routes = settings.routes || {};
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var addUrl = routes.cart_add_url || rootUrl + "cart/add.js";
      var cartUrl = routes.cart || rootUrl + "cart";
      var cartDrawer = document.querySelector("m-cart-drawer");
      var useDrawer = !!cartDrawer && settings.enable_cart_drawer !== false;

      button.classList.add("m-spinner-loading");
      button.setAttribute("disabled", "disabled");

      var formData = new FormData(form);
      if (useDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        var sectionIds = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        formData.append("sections", sectionIds.join(","));
        formData.append("sections_url", window.location.pathname);
      }

      fetch(addUrl, {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            showError(data.description || data.message || "Sorry, this item could not be added to your cart.");
            return;
          }

          if (useDrawer) {
            cartDrawer.renderContents(data);
            cartDrawer.getCart().then(function (cart) {
              cartDrawer.updateCartCount(cart.item_count);
              document.querySelectorAll(".cart-count-badge").forEach(function (badge) {
                badge.textContent = cart.item_count;
              });
            });
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
            }
          } else {
            window.location = cartUrl;
          }
        })
        .catch(function () {
          // Fall back to the cart page if the AJAX request fails for any reason.
          window.location = cartUrl;
        })
        .finally(function () {
          button.classList.remove("m-spinner-loading");
          button.removeAttribute("disabled");
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
